/** Phone numbers (test / demo) that may delete their candidate account from the app. */
const ALLOWED_NUMBERS = ["9191919191", "8181818181", "7171717171","8282828282"] as const;

function digitsOnly(phone: string): string {
  return phone.replace(/\D/g, "");
}

export function isCandidateDeleteAccountAllowed(phone: string | undefined | null): boolean {
  if (!phone) return false;
  const d = digitsOnly(phone);
  for (const n of ALLOWED_NUMBERS) {
    if (d === n) return true;
    if (n.length === 10 && d === `91${n}`) return true;
  }
  return false;
}
